import React from 'react';
import {Typography, Grid, Dialog, DialogTitle, DialogContent, List, ListItem} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import {formatDate} from '../components/utils/date';

export default function ActionModal({action, labels, open, onClose, color, signed_user}) {
    const classes = makeStyles(theme => ({
        dates: {
            color: '#787778',
            fontSize: '13px'
        },
        program: {
            backgroundColor: color,
            padding: '3px 10px',
            marginBottom: 10,
            color: theme.palette.getContrastText(color),
            fontSize: 14,
            borderRadius: 5,
            width: "max-content"
        },
        name: {
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
        },
        divider: {
            margin: 20
        },
        subtitle: {
            color: '#a0adb7'
        },
        section:{
            padding: "10px 0px 10px 0px"
        },
        list: {
            paddingTop: 0
        },
        listItem: {
            paddingLeft: 0
        },
        entity: {
            color: '#787778'
        }
    }))();
    return (
        <Dialog open={open} onClose={onClose} scroll='paper' maxWidth='lg' fullWidth>
            <DialogTitle>
                <Grid container justifyContent='space-between'>
                    <Grid xs={8} item>
                        {action.name}:
                    </Grid>
                    <Grid item>
                        <Grid container style={{borderRadius: '25px', border: '2px solid black', padding: '10px'}}>
                            <Typography>{action.status}</Typography>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Grid container>
                            <Typography>{labels.program}: {action.program}</Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </DialogTitle>
            <DialogContent>
                <Typography variant="body2">{action.description}</Typography>
               <Grid item xs={12} style={{display: 'flex', justifyContent: 'space-between'}} className={classes.section}>
                    <Grid item xs={12}>
                        <Typography variant="body1" className={classes.subtitle} style={{ fontWeight: 600, marginRight: 15 }}>{labels.projectDate}</Typography>
                        <Typography variant="subtitle2" component="span" className={classes.dates}>
                            {labels.startDate}: {formatDate(action.startDate)} | {labels.endDate}: {formatDate(action.endDate)}
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="body1" className={classes.subtitle} style={{ fontWeight: 600, marginRight: 15 }}>{labels.postulationDate}</Typography>
                        <Typography variant="subtitle2" component="span" className={classes.dates}>
                            {labels.submitDate}: {formatDate(action.submitDate)} | {labels.resultDate}: {formatDate(action.resultDate)}
                        </Typography>
                    </Grid>
                </Grid>

                <Grid item xs={12} className={classes.section}>
                    <Typography variant="body1" className={classes.subtitle}>
                        {labels.partners}
                    </Typography>
                    <Typography variant="body2">
                        {action.partners}
                    </Typography>
                </Grid>

                {signed_user && <Grid item xs={12} className={classes.section}>
                    <Typography variant="body1" className={classes.subtitle}>
                        {labels.people}
                    </Typography>
                    <List dense className={classes.list}>
                        {action.people.map((p, i) => {
                            const personEntity = action.partnersNames.find((n, index)=>action.partnersArray[index] === p.entity);
                            return  <ListItem key={`person_${i}`} className={classes.listItem}>
                                <Typography variant='body2'>
                                    {p.name}  <span className={classes.entity}>- {personEntity}</span>
                                </Typography>
                            </ListItem>
                        })}
                    </List>
                </Grid>}
            </DialogContent>
        </Dialog>
    );
}